<template>
  <b-modal :visible="visible" no-close-on-backdrop no-close-on-esc centered body-class="visit-type-list-body">
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form-group>
      <b-form-radio-group v-model="filterByVisitType"
                          :options="filterOptions"
                          stacked
                          name="filterOption">
      </b-form-radio-group>
    </b-form-group>
    <transition name="slide">
      <b-form-group v-show="filterByVisitType">
        <b-form-checkbox
            v-model="allSelected"
            @change="toggleAll"
        >
          {{ allSelected ? 'Un-select All' : 'Select All' }}
        </b-form-checkbox>
        <b-form-checkbox
            v-for="visitType in visitTypes" :key="visitType.organizationVisitTypeId"
            :id="'visitType-' + visitType.organizationVisitTypeId"
            class="ml-4"
            stacked
            v-model="visitTypeIds"
            :value="visitType.organizationVisitTypeId"
        >{{ visitType.name }}
        </b-form-checkbox>
      </b-form-group>
    </transition>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="saveVisitTypeIds()">Save</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>
<script>
  import _ from 'lodash'
  export default {
    name: 'visit-type-select',

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      selectedVisitTypeIds: {
        type: Array,
        required: true
      },
      isVisitCategory: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        visitTypeIds: _.clone(this.selectedVisitTypeIds),
        filterByVisitType: this.selectedVisitTypeIds.length > 0,
        allSelected: false
      }
    },
    watch: {
      selectedVisitTypeIds (newValue) {
        this.visitTypeIds = _.clone(newValue)
        if (newValue.length === 0) {
          this.allSelected = false
        } else if (newValue === this.allVisitTypeIds) {
          this.allSelected = true
        } else {
          this.allSelected = false
        }
      }
    },

    computed: {
      visitTypes () {
        return this.$store.organization.visitTypes
      },
      allVisitTypeIds () {
        return this.visitTypes.map(aVisitType => {
          return aVisitType.organizationVisitTypeId
        })
      },
      filterOptions () {
        if (this.isVisitCategory === true) {
          return [{ text: 'All Visit Categories', value: false },
                  { text: 'Select Visit Categories', value: true }
          ]
        } else {
          return [{ text: 'All Intake Flows', value: false },
                  { text: 'Select Intake Flows', value: true }
          ]
        }
      },
      title () {
        if (this.isVisitCategory === true) {
          return 'Select Visit Category'
        } else {
          return 'Select Intake Flow'
        }
      }
    },
    methods: {
      toggleAll (checked) {
        this.visitTypeIds = checked ? this.allVisitTypeIds : []
      },
      saveVisitTypeIds () {
        if (this.filterByVisitType) {
          this.$emit('saveVisitTypeIds', this.visitTypeIds)
        } else {
          this.visitTypeIds = []
          this.$emit('saveVisitTypeIds', [])
        }
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
